import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ProtectedRoute from '../Components/ProtectedRoute';
import NavBar from '../Components/NavBar/NavBar';
import Home from '../Components/Home/Home';
import Login from '../Components/Login/Login';
import ChooseNME from '../Components/ChooseNME/ChooseNME';
import AuthContextProvider from '../Context/AuthContext';
import StudentContextProvider from '../Context/StudentContext';
import Logout from '../Components/Logout/Logout';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Footer from '../Components/Footer/Footer';

const Style = {
  minHeight: '100vh'
}

function App() {
  return (
    <div>
      <div style={Style}>
        <AuthContextProvider>
          <StudentContextProvider >
            <Router>
              <NavBar />
              <Switch>
                <ProtectedRoute exact path='/' component={Home} />
                <ProtectedRoute exact path='/choose-nme' component={ChooseNME} />
                {/* <Route exact path='/' component={Home} />
                <Route exact path='/choose-nme' component={ChooseNME} /> */}
                <Route exact path='/login' component={Login} />
                <Route exact path='/logout' component={Logout} />
              </Switch>
            </Router>
          </StudentContextProvider>
        </AuthContextProvider>
      </div >
      <Footer />
    </div>
  );
}
export default App;